import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './js/App';
import reportWebVitals from './reportWebVitals';

// Le HTML pré-rendu (scripts/prerender.js) sert aux robots ; côté navigateur React remplace ce contenu par un rendu neuf
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
